function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M254.2355,175.353a64.7345,64.7345,0,0,0-48.7005-48.69,65.6519,65.6519,0,0,0-78.943,78.9329,64.7284,64.7284,0,0,0,48.7,48.7208A67.8765,67.8765,0,0,0,190.3129,256a65.5408,65.5408,0,0,0,63.9226-80.6468ZM150.7961,212.33a2.2838,2.2838,0,0,1-.4639-.6553,44.7794,44.7794,0,0,1,8.0649-53.2269,46.4556,46.4556,0,0,1,53.3176-8.0747,2.51,2.51,0,0,1,.5746,4.0323L154.3648,212.34A2.5284,2.5284,0,0,1,150.7961,212.33Zm60.8278,18.2564a45.4611,45.4611,0,0,1-42.4907,0v.03a2.5153,2.5153,0,0,1-1.0383-3.4072,2.58,2.58,0,0,1,.4636-.6251l57.995-57.995a2.47,2.47,0,0,1,2.1372-.7058,2.5165,2.5165,0,0,1,1.8548,1.28A45.4464,45.4464,0,0,1,211.6239,230.586Z",
  fill: "red"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 13.999,
  y: 143.1697,
  width: 43.1491,
  height: 86.2982,
  rx: 7.1915,
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.1145,190.4246a81.161,81.161,0,0,1,4.2977-26.0771V107.2122a7.1942,7.1942,0,0,0-7.1915-7.1916H77.4547a7.1942,7.1942,0,0,0-7.1916,7.1916V222.2764a7.1942,7.1942,0,0,0,7.1916,7.1915h28.766a7.1941,7.1941,0,0,0,7.1915-7.1915v-5.7748A81.1609,81.1609,0,0,1,109.1145,190.4246Z",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.6763,111.7958V64.063a7.194,7.194,0,0,0-7.1914-7.1914H133.7188a7.194,7.194,0,0,0-7.1915,7.1914v76.11A81.3435,81.3435,0,0,1,169.6763,111.7958Z",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M190.4246,109.1145a80.9735,80.9735,0,0,1,35.5159,8.1536V20.914a7.1941,7.1941,0,0,0-7.1915-7.1915H189.9829a7.1941,7.1941,0,0,0-7.1915,7.1915v88.5685C185.3057,109.2484,187.8491,109.1145,190.4246,109.1145Z",
  fill: "#fff"
});

var SvgWebappIconOfflineDarkTheme = function SvgWebappIconOfflineDarkTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconOfflineDarkTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-offline-dark-theme.ac268b07.svg";
export { ForwardRef as ReactComponent };